
import StreamChat from "@/components/livestream/StreamChat"
import defaultMeta from "@/mixins/defaultMeta"
import breadcrumb from "@/mixins/breadcrumb"
import { mapActions, mapGetters } from "vuex"
import { mdiClose, mdiPlus } from "@mdi/js"
import Modal from "@/components/base/modal/Modal"
import RequestLogin from "@/components/user/RequestLogin"
export default {
    name: "LivestreamChat",
    components: {
        RequestLogin,
        Modal,
        StreamChat,
    },
    mixins: [breadcrumb, defaultMeta],
    data: () => {
        return {
            mdiPlus,
            mdiClose,
            selfMessageThresholdLoading: false,
            messageThresholdChangeLoading: false,
        }
    },
    computed: {
        ...mapGetters("livestream", [
            "chatIsPublic",
            "messageThreshold",
            "selfMessageThreshold",
            "shouldLoginToSendMessages",
        ]),
        threshold: {
            get() {
                return this.messageThreshold
            },
            async set(newValue) {
                if (newValue === -1 && this.messageThreshold === 0) return
                this.messageThresholdChangeLoading = true
                await this.sendLivestreamUpdateRequest({
                    message_threshold: newValue,
                })
                this.messageThresholdChangeLoading = false
            },
        },
        selfThreshold: {
            get() {
                return this.selfMessageThreshold
            },
            async set(newValue) {
                if (newValue === -1 && this.selfMessageThreshold === 0) return
                this.selfMessageThresholdLoading = true
                await this.sendLivestreamUpdateRequest({
                    self_message_threshold: newValue,
                })
                this.selfMessageThresholdLoading = false
            },
        },
    },
    methods: {
        ...mapActions("livestream", ["sendLivestreamUpdateRequest"]),
        changeMessageThreshold(value) {
            if (value === -1 && this.messageThreshold === 0) return
            this.threshold += value
        },
        changeChatMode(value) {
            this.sendLivestreamUpdateRequest({
                public: value,
            })
        },
        closeLoginToSendMessageModal() {
            this.$store.commit(
                "livestream/SET_SHOULD_LOGIN_TO_SEND_MESSAGE",
                false
            )
        },
    },
}
